import script from "./tcgapas.vue?vue&type=script&setup=true&lang=js"
export * from "./tcgapas.vue?vue&type=script&setup=true&lang=js"

import "./tcgapas.vue?vue&type=style&index=0&id=5a41d84a&scoped=true&lang=css"

import exportComponent from "D:\\Desktop\\项目\\陈观梅\\vue-notus-main\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a41d84a"]])

export default __exports__